import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Edit } from "@material-ui/icons";
import { monthWithPrefix } from "../../../Common/Common";
import * as code from "../../../../config/Constants";

class Review extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.getUserData(),
    };
  }

  /**
   * @desc jump to other step for edit information
   */
  stepChange(step) {
    this.props.jumpToStep(step);
  }

  render() {
    return (
      <div className="step-content last-step">
        <Row>
          <Col>
            <h4 className="title-blue mb-3">Personal Information</h4>
          </Col>
          <Col className="col-auto">
            <Button
              variant="transparent"
              className="edit-icn p-0"
              onClick={() => this.stepChange(0)}
            >
              <Edit />
            </Button>
          </Col>
        </Row>

        <Form className="form-sm">
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Username</Form.Label>
                <p className="form-val">{this.state.user.username}</p>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>First Name</Form.Label>
                <p className="form-val">{this.state.user.firstname}</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Last Name</Form.Label>
                <p className="form-val">{this.state.user.lastname}</p>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Email ID</Form.Label>
                <p className="form-val email-case">{this.state.user.email}</p>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Create Password</Form.Label>
                <p className="form-val">******</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Confirm Password</Form.Label>
                <p className="form-val">******</p>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Mobile No.</Form.Label>
                <p className="form-val">{this.state.user.mobileNumber}</p>
              </Form.Group>
            </Col>
          </Row>
        </Form>
        <Form className="form-sm">
          {/* <Row>
            <Col>
              <h4 className="title-blue mb-2">Commission</h4>
            </Col>
          </Row> */}
          {/* <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Agent %</Form.Label>
                <p className="form-val">{this.state.user.agentPercent}%</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Brokerage %</Form.Label>
                <p className="form-val">{this.state.user.brokerPercent}%</p>
              </Form.Group>
            </Col>
          </Row> */}
        </Form>
      </div>
    );
  }
}

export default Review;
